import { call, put } from 'redux-saga/effects';
import { BACKEND_URL } from '../../../configs';
import makeRequest from '../../../utils/makeRequest';
import { OK } from '../../../configs/serverStatusCodes';
import { loadStatParkingMeterFailed, loadStatParkingMeterSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import processError from '../../../utils/processError';

export default function* loadStatParkingMeter(action) {
  try {
    const url = `${BACKEND_URL}/host-statuses/total`;
    const pool = { filter: { type: 1 } };
    const userDataResponse = yield makeRequest(url, pool, action, 'POST');
    const responseJson = yield userDataResponse.json();
    if (userDataResponse && userDataResponse.status === OK && responseJson.result) {
      yield put(loadStatParkingMeterSuccessful(responseJson.result));
      yield call(resolveActionPromise(action, responseJson));
    } else {
      yield put(loadStatParkingMeterFailed());
      yield call(rejectActionPromise(action, responseJson));
    }
  } catch (e) {
    yield put(loadStatParkingMeterFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
